var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"z-10",class:{'push-top': _vm.pushTop, 'push-bottom': _vm.pushBottom}},[_c('div',{staticClass:"mx-auto max-w-2xl"},[_c('div',{staticClass:"bg-blue-100 p-10 shadow-lg "},[_vm._t("default")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }